import { Link } from '@tanstack/react-router';
import { useBusinessFooter } from '@/hooks/useRankings';
import { routes } from '@/routes/paths';

export function DashboardFooter() {
  const { data, isLoading } = useBusinessFooter();
  const year = new Date().getFullYear();
  const businessName = data?.businessName || 'Ezzo';
  const footerText = data?.footerText || '';
  const version = data?.softwareVersion || '';

  return (
    <footer className="dash-footer" role="contentinfo">
      <div className="dash-footer-copy">
        © {year} {businessName}
        {footerText ? <span className="dash-footer-text"> {footerText}</span> : null}
        {isLoading ? <span className="muted"> </span> : null}
      </div>
      <nav className="dash-footer-links" aria-label="Footer">
        <Link to={routes.settingsBusiness as never}>Business Setup</Link>
        <Link to={routes.settings as never}>Profile</Link>
        <Link to={routes.dashboard as never}>Home</Link>
      </nav>
      {version ? (
        <div className="dash-footer-version muted">Software version: {version}</div>
      ) : null}
    </footer>
  );
}
